import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const WorkshopsPage = () => {
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-735" data-mp="23iqf81dug0d0">
      <Header data-id="element-736" data-mp="28a88025pqumw" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-737" data-mp="28armta02h2wp">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-738" data-mp="28cclnbtez80d">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-739" data-mp="2d9bdtotip4vx">
            <Navigation data-id="element-740" data-mp="2i7wbphlarch7" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-741" data-mp="2i6uramie5dmt">
            <div className="max-w-2xl" data-id="element-742" data-mp="2ma13sbw3k11q">
              <div className="mb-8" data-id="element-743" data-mp="2mb2eugd44njg">Workshops for 2026</div>
              <div className="mb-8" data-id="element-744" data-mp="2r9m52syqolhm">
                <div className="mb-1 line-through" data-id="element-745" data-mp="2r8kragqc9kw7">
                  The Winter Practice Workshop (Online)
                </div>
                <div className="mb-1 line-through" data-id="element-746" data-mp="wvctqhazav6v">
                  Saturdays 9am - 12pm EST
                </div>
                <div className="mb-1 line-through" data-id="element-747" data-mp="2ykpekseuvac1">
                  January 24th - February 21st, 2026
                </div>
                <div data-id="element-748" data-mp="2tsntcgzpm99v">
                  <span className="line-through" data-id="element-749" data-mp="2ts625yrwml8t">
                    <Link to="/winter-practice-workshop" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-750" data-mp="2prcdh36n12ev">
                      Register here
                    </Link>
                  </span>{' '}
                  <span className="text-[#333333]" data-id="element-751" data-mp="33iqw38wmv1le">SOLD OUT</span>
                </div>
              </div>
              <div className="mb-8" data-id="element-752" data-mp="1x4rkxzefek9q">
                <div className="mb-1 line-through" data-id="element-753" data-mp="1s43lcpc4sv3w">
                  Try Something New: 100 Images in Two Days
                </div>
                <div className="mb-1 line-through" data-id="element-754" data-mp="1tmc0n2v3m6f5">
                  In-Person @{' '}
                  <a href="https://www.penumbrafoundation.org/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-755" data-mp="1yklw7ekqj91a">
                    Penumbra Foundation
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-756" data-mp="15v6lyr0w9k6f">
                  April 22nd - April 24th, 2026
                </div>
                <span className="line-through" data-id="element-757" data-mp="rwykc5swxuox">
                  <a href="https://www.penumbrafoundation.org/workshops/try-something-new-100-images-in-two-days" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-758" data-mp="ry9my2amgweg">
                    Register here
                  </a>
                </span>
              </div>
              <div className="mb-8" data-id="element-759" data-mp="r87skqih8fp2">
                <div className="mb-1 line-through" data-id="element-760" data-mp="r7538n0sylb9">
                  Saturday Critique Group 1 (Online)
                </div>
                <div className="mb-1 line-through" data-id="element-761" data-mp="10y9at1o5f3w2">
                  Every four weeks, starting June 20th
                </div>
                <div className="mb-1 line-through" data-id="element-762" data-mp="1ezdbxfnmlq44">9am - 11:30am EST</div>
                <div data-id="element-763" data-mp="1axrq34t461hs">
                  <span className="line-through" data-id="element-764" data-mp="1ay9tqmi3vhzq">Register here</span>{' '}
                  <span className="text-[#333333]" data-id="element-765" data-mp="34gh8l0oer75z">SOLD OUT</span>
                </div>
              </div>
              <div className="mb-8" data-id="element-766" data-mp="39e0l9w5gjbvt">
                <div className="mb-1 line-through" data-id="element-767" data-mp="39cxy9zb99tl6">
                  Try Something New: 100 Images in Two Days
                </div>
                <div className="mb-1 line-through" data-id="element-768" data-mp="3j4c2gke5jhkn">
                  Online @{' '}
                  <a href="https://www.penumbrafoundation.org/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-769" data-mp="3j6epcvk0cul5">
                    Penumbra Foundation
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-770" data-mp="es870l1ae5jv">Wednesdays, 6-8pm EST</div>
                <div className="mb-1 line-through" data-id="element-771" data-mp="1z7mqokvacyv0">
                  August 12th - September 16, 2026 (skipping Sept 2nd)
                </div>
                <div data-id="element-772" data-mp="1qfui6fptnzt2">
                  <span className="line-through" data-id="element-773" data-mp="1qf2pbcnm0g6h">
                    <a href="https://www.penumbrafoundation.org/online-courses/100-images-30-days" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-774" data-mp="1qdrmpg5whegy">
                      Register here
                    </a>
                  </span>{' '}
                  <span className="text-[#333333]" data-id="element-775" data-mp="2wxhqqzglhnoq">SOLD OUT</span>
                </div>
              </div>
              <div className="mb-8" data-id="element-776" data-mp="3fz8gb9r8ulvc">
                <div className="mb-1 line-through" data-id="element-777" data-mp="3fyyrhphxqkr8">
                  The Sum of the Parts: A Writing and Photography Workshop
                </div>
                <div className="mb-1 line-through" data-id="element-778" data-mp="3716bsk8axb3b">
                  Co-led by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-779" data-mp="3byeuqn19xj5m">
                    Vivian Ewing
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-780" data-mp="2ja93rijmmxxc">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-781" data-mp="2bqzvxtqrr7ae">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-782" data-mp="21stwrjwckf98">
                  August 24th - August 28th, 2026
                </div>
                <span className="line-through" data-id="element-783" data-mp="1x1vdcbg2b11r">
                  <a href="https://www.mainemedia.edu/workshops/item/the-sum-of-the-parts-a-writing-and-photography-workshop/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-784" data-mp="1x00qusp570vk">
                    Register here
                  </a>
                </span>
              </div>
              <div className="mb-8" data-id="element-785" data-mp="12ppa913szaay">
                <div className="mb-1 line-through" data-id="element-786" data-mp="12onvomnkw5oh">
                  Photography & Storytelling: Thinking About the Photo Book
                </div>
                <div className="mb-1 line-through" data-id="element-787" data-mp="1bjtwf77zrxk5">
                  In-Person @{' '}
                  <a href="https://www.mainemedia.edu/workshops/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-788" data-mp="1gi55vgudk61u">
                    Maine Media Workshops
                  </a>
                </div>
                <div className="mb-1 line-through" data-id="element-789" data-mp="2w1mlo9uarlh3">
                  September 21st - September 25th, 2026
                </div>
                <div data-id="element-790" data-mp="3to22raitah44">
                  <span className="line-through" data-id="element-791" data-mp="3tqob3cdj10ne">
                    <a href="https://www.mainemedia.edu/workshops/item/photography-and-storytelling-thinking-about-the-photo-book/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-792" data-mp="3oqjqba5l5jrd">
                      Register here
                    </a>
                  </span>
                </div>
              </div>
              <div className="mb-12" data-id="element-793" data-mp="1mqcmjx3kfrxb">
                <div data-id="element-794" data-mp="1hpor8z8b0oxa">
                  One-on-one mentorship follows the{' '}
                  <a href="https://santafeworkshops.com/sfw-online/mentorships/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-795" data-mp="1hrrljvghp47t">
                    Santa Fe Mentorship Level 1
                  </a>{' '}
                  model. Email me directly to enquire.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WorkshopsPage;